module.exports = __webpack_public_path__ + "img/document_sign.71a0fa56.svg";